import { SubmitButton } from "ayasofyazilim-mobile-ui";
import { Text, View } from "react-native";

export function AskCameraPermission({
  requestPermission,
}: {
  requestPermission: () => Promise<any>;
}) {
  return (
    <View className="w-full flex-1 justify-center items-center">
      <Text>Kamerayı kullanabilmek için izninize ihtiyacımız var.</Text>
      <SubmitButton
        onSubmit={requestPermission}
        className="mt-4 py-4 px-6 gap-3"
        icon="camera"
        variant={"outline"}
      >
        İzni Ver
      </SubmitButton>
    </View>
  );
}
